module.exports = __webpack_public_path__ + "img/6Tyskland.14bcd282.png";